import * as React from 'react';

const DOT_EYES = (
    <>
        <circle cx="8.75" cy="9.5" r="1.1" fill="currentColor" stroke="none" />
        <circle cx="15.25" cy="9.5" r="1.1" fill="currentColor" stroke="none" />
    </>
);

/**
 * Worst to best: frown, slanted mouth, flat line, smile, grin. Each mouth is a
 * different shape so neighbouring faces stay distinct at 22px.
 */
const FEATURES: Record<number, React.ReactElement> = {
    1: (
        <>
            {DOT_EYES}
            <path
                d="M7.25 17.75c1.6-3.6 7.9-3.6 9.5 0"
                fill="none"
                strokeWidth={2.1}
            />
        </>
    ),
    2: (
        <>
            {DOT_EYES}
            <path d="M8.75 16.5 15.25 14.75" fill="none" />
        </>
    ),
    3: (
        <>
            {DOT_EYES}
            <path d="M8.5 15.25h7" fill="none" />
        </>
    ),
    4: (
        <>
            {DOT_EYES}
            <path d="M8.5 14.25c1.4 1.7 5.6 1.7 7 0" fill="none" />
        </>
    ),
    5: (
        <>
            <path
                d="M7.25 10.25c.6-1.5 2.4-1.5 3 0M13.75 10.25c.6-1.5 2.4-1.5 3 0"
                fill="none"
            />
            <path
                d="M7.75 13.5h8.5a4.25 4.25 0 0 1-8.5 0z"
                fill="currentColor"
            />
        </>
    ),
};

export interface IRatingFaceProps {
    /** 1 (worst) to 5 (best). */
    rating: number;
    className?: string;
}

/**
 * One face of the scale, drawn rather than an emoji so it looks the same
 * everywhere. Decorative: the button carries the name.
 */
export const RatingFace: React.FunctionComponent<IRatingFaceProps> = ({
    rating,
    className,
}) => (
    <svg
        viewBox="0 0 24 24"
        aria-hidden="true"
        focusable="false"
        className={className}
        stroke="currentColor"
        strokeWidth={1.75}
        strokeLinecap="round"
        strokeLinejoin="round"
        data-testid={`feedback-rating-face-${rating}`}
    >
        <circle cx="12" cy="12" r="10" fill="none" />
        {FEATURES[rating]}
    </svg>
);
